import { render, staticRenderFns } from "./create-project.vue?vue&type=template&id=94cdef36&scoped=true&"
import script from "./create-project.vue?vue&type=script&lang=js&"
export * from "./create-project.vue?vue&type=script&lang=js&"
import style0 from "./create-project.vue?vue&type=style&index=0&id=94cdef36&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cdef36",
  null
  
)

export default component.exports